// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Brand palette, sampled straight out of src/assets/ST_logo_onwhite.png:
//   #FFE716 — Sea Tow yellow
//   #231F20 — Sea Tow ink
// Yellow can't carry body text (it fails contrast on white), so it is used as
// an accent — active nav, card top rules, focus — while ink carries the
// buttons in light mode. Dark mode flips it: yellow reads well as primary
// against a dark surface and takes dark text on top.
const BRAND_YELLOW = '#FFE716'
const BRAND_INK = '#231F20'

const light = {
  dark: false,
  colors: {
    background: '#F3F4F6',
    surface: '#FFFFFF',
    primary: BRAND_INK,
    secondary: BRAND_YELLOW,
    accent: BRAND_YELLOW,
    error: '#B3261E',
    info: '#1B6FA8',
    success: '#1B7F4B',
    warning: '#A66300',
  },
}

const dark = {
  dark: true,
  colors: {
    background: '#141619',
    surface: '#1E2126',
    primary: BRAND_YELLOW,
    secondary: BRAND_YELLOW,
    accent: BRAND_YELLOW,
    error: '#F2B8B5',
    info: '#7FC4EE',
    success: '#7BD5A3',
    warning: '#F0C05A',
  },
}

// Resolve the initial theme: an explicit saved choice wins, otherwise default
// to light (we intentionally do not follow the OS dark-mode preference).
function initialTheme() {
  const saved = localStorage.getItem('theme')
  return saved === 'dark' ? 'dark' : 'light'
}

export default createVuetify({
  theme: {
    defaultTheme: initialTheme(),
    themes: { light, dark },
  },
  defaults: {
    VCard: { rounded: 'lg' },
    VTextField: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VBtn: { rounded: 'lg' },
  },
})
